/**
 * Класс, назначаемый, когда кнопку нужно показать.
 */
 const CLASS_VISIBLE = 'visible';

 /**
  * Класс, назначаемый, когда кнопку нужно остановить перед подвалом.
  */
 const CLASS_BEFORE_FOOTER = 'before-footer';
 
 /**
  * Инициализация баннера онлайн-офиса.
  * 
  * @returns Функция для обработчика прокрутки страницы.
  */
 function main(): ( pageY: number ) => void
 {
	 const onlineOffice : HTMLElement = document.querySelector( 'body>div.popup' ) as HTMLElement;
	 
	 if ( !onlineOffice || !document.body.classList.contains( 'index' ) && !document.body.classList.contains( 'choose' ) )
	 {
		 return () => undefined;
	 }
 
	 if ( sessionStorage.getItem( 'to-banner-closed' ) )
	 {
		 onlineOffice.style.display = 'none';
		 return () => undefined;
	 }
	 
	 const closeButton = onlineOffice.querySelectorAll( 'button[type="button"]' );
 
	 if ( closeButton.length > 0 )
	 {
		 Array.from( closeButton ).forEach( ( it ) => {
			 it.addEventListener(
				 'click',
				 ( evt : MouseEvent ) =>
				 {
					 evt.preventDefault();
					 sessionStorage.setItem( 'to-banner-closed', '1' );
					 onlineOffice.style.display = 'none';
				 }
			 );
		 } );
	 }
	 
	 let visible: boolean = onlineOffice.classList.contains( CLASS_VISIBLE );
	 let beforeFooter : boolean = onlineOffice.classList.contains ( CLASS_BEFORE_FOOTER );
	 
	 return ( pageY: number ) =>
	 {
		 if ( visible && pageY === 0 )
		 {
			 visible = false;
			 onlineOffice.classList.remove( CLASS_VISIBLE );
		 }
		 else if ( !visible && pageY > 0 )
		 {
			 visible = true;
			 onlineOffice.classList.add( CLASS_VISIBLE );
		 }
 
		 const footer = document.querySelector( 'footer' );
 
		 if ( !footer )
		 {
			 return;
		 }
 
		 let isFooterVisible : boolean = footer.getBoundingClientRect().top < window.innerHeight;
 
		 if ( beforeFooter && !isFooterVisible )
		 {
			 beforeFooter = false;
			 onlineOffice.classList.remove( CLASS_BEFORE_FOOTER );
		 }
		 else if ( !beforeFooter && isFooterVisible )
		 {
			 beforeFooter = true;
			 onlineOffice.classList.add( CLASS_BEFORE_FOOTER );
		 }
	 };
 }
 
 /**
  * Module.
  */
 export {
	 main as default,
 };


// WEBPACK FOOTER //
// ./app/Common/Scroll/onlineOffice.ts